'use client';
import { useThemeSetting, useThemeStyles } from '../../provider/index.js';
import { useBlock } from './useBlock.js';
/**
 * Returns the block style (if available)
 *
 * @param node DomNode
 * @returns
 */
export function useBlockSpacing(node) {
    var _a, _b, _c, _d, _e, _f;
    const { name, attributes } = useBlock(node);
    const supportsBlockGap = !!useThemeSetting('spacing.blockGap', name);
    const supportsMargin = !!useThemeSetting('spacing.margin', name);
    const supportsPadding = !!useThemeSetting('spacing.padding', name);
    const styles = useThemeStyles();
    return {
        padding: (_b = (_a = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.padding,
        margin: (_d = (_c = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _c === void 0 ? void 0 : _c.spacing) === null || _d === void 0 ? void 0 : _d.margin,
        supportsMargin,
        supportsPadding,
        supportsBlockGap,
        blockGap: supportsBlockGap && ((_e = styles === null || styles === void 0 ? void 0 : styles.spacing) === null || _e === void 0 ? void 0 : _e.blockGap) ? (_f = styles === null || styles === void 0 ? void 0 : styles.spacing) === null || _f === void 0 ? void 0 : _f.blockGap : '',
    };
}
